import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalComponent, ModalService } from '../common/modal/modal.component';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class formDialogService {

    constructor(private modalService:ModalService, private translate: TranslateService){}

    confirm() {
        let confirmation = this.modalService.show('Are you sure?', this.translate.instant("ConfirmPopup"));
        // return Observable.of(confirmation)
        return(confirmation);
    }
}